<template>
  <div
    class="mb-0"
    :class="[
      titleClass,
      showBorderBottom?'border-bottom':'',
      borderType,
      $vuetify.theme.dark?'':'titulo_nitro',
      paddingContainerHeader

    ]"
  >
    <div class="d-flex justify-content-between w-100">
      <div class="d-flex align-items-center w-100">
        <slot>
          <slot name="preffixTitle" />  {{ text }} <slot name="suffixTitle" />
        </slot>
      </div>
      <slot name="right" />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    text: {
      type: String,
      required: false,
      default: ''
    },
    titleClass: {
      type: String,
      default: 'h6'
    },
    showBorderBottom: {
      type: Boolean,
      default: true,
    },
    borderType: {
      type: String,
      default: 'border-deep-dark'
    },
    paddingContainerHeader: {
      type: String,
      required: false,
      default: 'p-4'
    }
  }
}
</script>
